import { baseURL, fetch } from "@/api/fetch";

export default class BaseApi {
  getBaseURL = () => baseURL;
  // url
  // type =  GET || POST
  // config { data, params, headers }
  request = (url, type = "GET", config = {}) =>
    fetch(url, type, config).then((res) => res.data);
}
